import { ViewModel,View, ObservableArray } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { ChildAcceptableFormBuilderElement, FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import  { DummyTablePlaceHolderComponentView } from "./dummyTablePlaceHolderComponent-view"
import { TdComponent } from "./td/td-viewModel";
import { TdDecoratorViewModel } from "./tdDecorator/tdDecorator-viewModel";


export class DummyTablePlaceHolderComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'DummyTablePlaceHolder';
        this.canAcceptContent = true;
        
        // this.addProperty("Content","",new ContentPropertyType(this),null,true);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new DummyTablePlaceHolderComponentElement(parent);

        return result;
    }
}

export class DummyTablePlaceHolderComponentElement extends ChildAcceptableFormBuilderElement{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.tds = ObservableArray.create<TdDecoratorViewModel>();
    }
    GetDefaultView(): View <ViewModel> {
        return new DummyTablePlaceHolderComponentView();
    }
    public getTypeId(): string {
        return "VM-B1A72198-94C6-4934-90C4-EF9C9C106F57"
    }

    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitDummyTablePlaceHolderComponentElement(this,parameter);
    }
    private location : number;
    private specificLocation : boolean;
    public set tds(v: ObservableArray<TdDecoratorViewModel>) { this._tds = v; } public get tds(): ObservableArray<TdDecoratorViewModel> { return this._tds;} private _tds: ObservableArray<TdDecoratorViewModel>;
    
    addChildInternal(element: FormBuilderElement): void {
        element.DataContext = this.DataContext;
        let decorator = new TdDecoratorViewModel(this);
        decorator.decoratorComponent = element;
        element.parentViewModel = decorator;
        element.decoratorHead = <any>decorator;

        if(this.specificLocation===true){
            this.children.insertAt(this.location,<any>decorator);
            this.tds.insertAt(this.location,decorator);
            this.specificLocation = false;
        }else{
            this.children.push(<any>decorator);
            this.tds.push(decorator);
        }
    }
    removeChild(element: FormBuilderElement): void {
        this.children.remove(element);
        this.tds.remove(<any>element.decoratorHead);
    }
    

    delete(arg0: TdDecoratorViewModel) {
        this.removeChild(<any>arg0);
    }
    addAfter(arg0: TdDecoratorViewModel) {
        let index = this.tds.indexOf(arg0);
        let newElement = new TdComponent(this).Create(this);
        this.specificLocation = true;
        this.location = index+1;
        this.addChild(newElement);
    }
    addBefore(arg0: TdDecoratorViewModel) {
        let index = this.tds.indexOf(arg0);
        let newElement = new TdComponent(this).Create(this);
        this.specificLocation = true;
        this.location = index;
        this.addChild(newElement);
    }
}
